// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"788":"14b21335","842":"cd4a8a7e"}[chunkId] + ".chunk.css";
};